import AllergyPage from "./AllergyPage";

export default AllergyPage;